// White-label brand config — see WHITELABEL.md.
export const BRAND = {
  name: 'Rainbow Nails',
  shortName: "Rainbow",
  legalName: 'Rainbow Nails',
  tagline: "Where Color Meets Care",
  vertical: 'other' as 'cleaning' | 'barbershop' | 'other',

  phone: '(732) 617-1555',
  phoneHref: 'tel:7326171555',
  email: 'book@rainbownails.com',
  domain: 'rainbow-nails-manalapan.pages.dev',

  logo: '/images/logo.svg',

  serviceArea: "Manalapan, NJ",

  trust: {
    bondedInsured: false,
    satisfactionGuarantee: true,
    yearsInBusiness: null as number | null,
    ecoFriendly: false,
  },

  social: {
    facebook: '',
    instagram: '',
    google: '',
  },

  bookingNoun: 'appointment',
  workerNoun: 'nail tech',
};

export default BRAND;
